// extracted by mini-css-extract-plugin
export default {"container":"DynamicIndicator_container__U7IpT","imageContainer":"DynamicIndicator_imageContainer__NQHDH","reversed":"DynamicIndicator_reversed__AH+tU"};